import type { RouteLocationRaw } from 'vue-router';
import {
  MCP_OAUTH_AUTHORIZE_ROUTE_NAME,
  OAUTH_QUERY_PARAM_STATE,
  REQUIRED_MCP_QUERY_PARAM_KEYS,
} from '../constants/mcpAuthorization.constant';

function isNonEmptyStringParam(query: Record<string, unknown>, key: string): boolean {
  const value = query[key];
  return typeof value === 'string' && value.length > 0;
}

/**
 * Indica si la query trae los parámetros obligatorios del flujo de autorización MCP.
 * `state` no se exige: es opcional en este contrato.
 *
 * @param query - Query de cualquier ruta (por ejemplo, la de `/auth/log-in`).
 */
export function hasMcpAuthorizationParams(query: Record<string, unknown>): boolean {
  return REQUIRED_MCP_QUERY_PARAM_KEYS.every((key) => isNonEmptyStringParam(query, key));
}

/**
 * Filtra una query a solo las claves del contrato OAuth del MCP, descartando
 * cualquier otro param que la ruta traiga.
 */
export function getMcpAuthorizationQuery(query: Record<string, unknown>): Record<string, string> {
  const mcpQuery: Record<string, string> = {};
  [...REQUIRED_MCP_QUERY_PARAM_KEYS, OAUTH_QUERY_PARAM_STATE].forEach((key) => {
    if (isNonEmptyStringParam(query, key)) {
      mcpQuery[key] = query[key] as string;
    }
  });
  return mcpQuery;
}

/**
 * Arma la ubicación de retorno a la pantalla de autorización MCP, preservando
 * los params OAuth de la query original.
 */
export function getMcpAuthorizeLocation(query: Record<string, unknown>): RouteLocationRaw {
  return { name: MCP_OAUTH_AUTHORIZE_ROUTE_NAME, query: getMcpAuthorizationQuery(query) };
}
